import React from 'react';
import { Header } from '../../features/header/Header';
import styled from 'styled-components';

import { Container, Table } from 'reactstrap';

const FieldName = styled.th`
  width: 25%;
`;

function IrsFieldSpecPage() {
  return (
    <>
      <Header />
      <Container>
        <h2 className="mb-4">Interest Rate Swaps Upload File Format</h2>
        <p>
          Trades should be uploaded in comma-delimited CSV files with all
          timestamps in ISO 8601 Date and Time format.
        </p>
        <h3 className="mb-4">Required Fields</h3>
        <Table>
          <thead>
            <tr>
              <FieldName>Field Name</FieldName>
              <th>Examples</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Component_Typology</td>
              <td>
                OIS, IRS, Xccy Swap, Non Deliv. Xccy Swap, Non Deliverable Swap,
                NDS, XCCY, NDXCCY
              </td>
            </tr>
            <tr>
              <td>Fixed_Rate</td>
              <td>2.1, 3.45, 1.9075</td>
            </tr>
            <tr>
              <td>Leg1_Currency</td>
              <td>USD, AUD, SGD</td>
            </tr>
            <tr>
              <td>Leg1_Day_Count</td>
              <td>Act/365, Act/360, Act/Act, 30/360 or null</td>
            </tr>
            <tr>
              <td>Leg1_Fixing</td>
              <td>FIXED, USD-SOFR, SGD-SORA, or other Reference Rate</td>
            </tr>
            <tr>
              <td>Leg1_Notional</td>
              <td>2500000</td>
            </tr>
            <tr>
              <td>Leg1_Pay_Frequency</td>
              <td>
                Monthly, Quarterly, Semi Annual, Annual, 7 Days, 28 Days, 91
                Days, Zero Coupon
              </td>
            </tr>
            <tr>
              <td>Leg2_Currency</td>
              <td>USD, AUD, SGD</td>
            </tr>
            <tr>
              <td>Leg2_Day_Count</td>
              <td>Act/365, Act/360, Act/Act, 30/360 or null</td>
            </tr>
            <tr>
              <td>Leg2_Fixing</td>
              <td>FIXED, USD-SOFR, SGD-SORA, or other Reference Rate</td>
            </tr>
            <tr>
              <td>Leg2_Notional</td>
              <td>2500000</td>
            </tr>
            <tr>
              <td>Leg2_Pay_Frequency</td>
              <td>
                Monthly, Quarterly, Semi Annual, Annual, 7 Days, 28 Days, 91
                Days, Zero Coupon
              </td>
            </tr>
            <tr>
              <td>Pay_Leg</td>
              <td>Leg1 or Leg2</td>
            </tr>
            <tr>
              <td>Trade_Datetime</td>
              <td>2015-08-29T11:22:09.815479+01:00</td>
            </tr>
            <tr>
              <td>Trade_id</td>
              <td>7654321, Z9Y8X7</td>
            </tr>
          </tbody>
        </Table>
        <h3 className="mb-4">Optional Fields</h3>
        <Table>
          <thead>
            <tr>
              <FieldName>Field Name</FieldName>
              <th>Examples</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Contract_id</td>
              <td>Any combination of alphabet and numbers</td>
            </tr>
            <tr>
              <td>Contract_Typology</td>
              <td>Any combination of alphabet and numbers</td>
            </tr>
            <tr>
              <td>Contract_Version</td>
              <td>Any combination of alphabet and numbers</td>
            </tr>
            <tr>
              <td>Counterparty</td>
              <td></td>
            </tr>
            <tr>
              <td>Cust_Type</td>
              <td></td>
            </tr>
            <tr>
              <td>Custom_Benchmark_1</td>
              <td>2.1, 3.45, 1.9075</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_2</td>
              <td>2.1, 3.45, 1.9075</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_3</td>
              <td>2.1, 3.45, 1.9075</td>
            </tr>
            <tr>
              <td>Custom_Benchmark_4</td>
              <td>2.1, 3.45, 1.9075</td>
            </tr>
            <tr>
              <td>Description</td>
              <td></td>
            </tr>
            <tr>
              <td>Economic Impact</td>
              <td>Economic, Non-Economic</td>
            </tr>
            <tr>
              <td>Effective_Date</td>
              <td>Dates in '2024-12-31' format</td>
            </tr>
            <tr>
              <td>Legal_Entity</td>
              <td>Entity, ENTITY, LEGAL_ENTITY</td>
              <td>Client-specific codes (e.g. LE_1, LE_2)</td>
            </tr>
            <tr>
              <td>Event Actor</td>
              <td>SYSIMPORT, MUREXBO</td>
            </tr>
            <tr>
              <td>Margin CCY</td>
              <td>USD, AUD, SGD</td>
            </tr>
            <tr>
              <td>Maturity_Date</td>
              <td>Dates in '2024-12-31' format</td>
            </tr>
            <tr>
              <td>Net_PL</td>
              <td>Numeric values (10000000)</td>
            </tr>
            <tr>
              <td>Orig Margin</td>
              <td>Numeric values (10000000)</td>
            </tr>
            <tr>
              <td>PL_CCY</td>
              <td>USD, AUD, SGD</td>
            </tr>
            <tr>
              <td>Portfolio</td>
              <td>Any combination of alphabet and numbers</td>
            </tr>
            <tr>
              <td>Report Date</td>
              <td>Dates in '2024-12-31' format</td>
            </tr>
            <tr>
              <td>Root_Contract_id</td>
              <td>Any combination of alphabet and numbers</td>
            </tr>
            <tr>
              <td>Strategy</td>
              <td>Any combination of alphabet and numbers</td>
            </tr>
            <tr>
              <td>System</td>
              <td>MARKITWIRE</td>
            </tr>
            <tr>
              <td>Tenor</td>
              <td>2Y, 10Y, 6M, 1W, etc.</td>
            </tr>
            <tr>
              <td>Trade_Event</td>
              <td>New trade</td>
            </tr>
            <tr>
              <td>Trade_Insertion_Datetime</td>
              <td>Date/Time in UTC format, e.g. '2024-01-26T13:34:31Z'</td>
            </tr>
            <tr>
              <td>Trader_ID</td>
              <td>Any combination of alphabet and numbers</td>
            </tr>
          </tbody>
        </Table>
        <br />
        <br />
        <br />
      </Container>
    </>
  );
}

export default IrsFieldSpecPage;
